import script from "./FinancialFitnessHistoryPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./FinancialFitnessHistoryPage.vue?vue&type=script&setup=true&lang=ts"

import "./FinancialFitnessHistoryPage.vue?vue&type=style&index=0&id=189ee65f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-189ee65f"]])

export default __exports__